export class QAccountDetails {
  constructor() {}

  GetStartDate() {
    return this.startDate;
  }

  SetStartDate(startdate) {
    this.startDate = startdate;
  }

  GetValidated() {
    return this.validated;
  }

  SetValidated(validated) {
    this.validated = validated;
  }

  SetPITActivated(pointintime) {
    this.pointintime = pointintime;
  }

  GetPITActivated() {
    return this.pointintime;
  }

  GetLegalName() {
    return this.legalName;
  }

  SetLegalName(orgname) {
    this.legalName = orgname;
  }

  GetKeyContact() {
    return this.keyContact;
  }

  SetKeyContact(keycontact) {
    this.keyContact = keycontact;
  }

  GetContactEmail() {
    return this.contactEmail;
  }

  SetContactEmail(contactemail) {
    this.contactEmail = contactemail;
  }

  GetNotes() {
    return this.notes;
  }

  SetNotes(notes) {
    this.notes = notes;
  }

  GetAccountType() {
    return this.accountType;
  }

  SetAccountType(accounttype) {
    this.accountType = accounttype;
  }

  GetConnectors() {
    return this.connectors;
  }

  SetConnectors(connectors) {
    this.connectors = connectors;
  }

  GetSource() {
    return this.source;
  }

  SetSource(source) {
    this.source = source;
  }

  GetChannel() {
    return this.channel;
  }

  SetChannel(channel) {
    this.channel = channel;
  }

  GetATS() {
    if (this.ats == null) this.ats = "Unknown";
    return this.ats;
  }

  SetATS(ats) {
    this.ats = ats;
  }

  GetCountry() {
    return this.country;
  }

  SetCountry(country) {
    this.country = country;
  }

  GetTerm() {
    return this.term;
  }

  SetTerm(term) {
    this.term = term;
  }

  GetDeployment() {
    return this.deployment;
  }

  SetDeployment(deployment) {
    this.deployment = deployment;
  }

  Clone() {
    var u = new QAccountDetails();
    //u.InitAccountDetails();

    for (var key in this) u[key] = this[key];

    return u;
  }

  SetDefaultParams() {
    this.startDate = "";
    this.keyContact = "";
    this.contactEmail = "";
    this.notes = "";
    this.accountType = "Customer";
    this.connectors = "Unknown";
    this.source = "OWS USA";
    this.channel = "Direct";
    this.ats = "Unknown";
    this.country = "United States";
    this.term = "Monthly";
    this.deployment = "Cloud";
    this.queryMethod = "Unknown";
    this.legalName = "";
    this.pointintime = false;
    this.planning = false;
    this.succession = false;
  }
}
